import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=239b8408&scoped=true"
import script from "./goods.vue?vue&type=script&lang=js"
export * from "./goods.vue?vue&type=script&lang=js"
import style0 from "./goods.vue?vue&type=style&index=0&id=239b8408&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239b8408",
  null
  
)

export default component.exports